<template>
  <v-row>
    <v-col cols="12">
      <v-card flat>
        <v-card-title v-if="sectionConfig.title" class="px-0" style="white-space: pre-line">{{ config.title }}</v-card-title>
        <v-card-text class="px-0 pb-0 mb-0">
          <document-list v-if="documents.length > 0" :documents="documents"></document-list>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import config from '@/common/config';
import dateUtils from '@/common/dateUtils';
import DocumentList from './DocumentList';
export default {
  name: 'DocumentsSelection',
  props: {
    config: {
      type: Object,
    },
  },
  components: {
    DocumentList,
  },

  computed: {
    documents() {
      /*
       "selection": {
                    "selectorTags": "Lernen",// Optional
                    "latestItems": "3" // Optional
                    "documentIds":[]
                  },
      */

      if (this.sectionConfig.DocumentsSelectionConfig.selection) {
        const { selectorTags, latestItems, documentIds } = this.sectionConfig.DocumentsSelectionConfig.selection;
        let docs;
        if (documentIds) {
          return documentIds.map((id) => this.$store.state.documents.documentsById[id]).filter((d) => d !== undefined);
        }
        if (selectorTags || latestItems) {
          docs = this.$store.state.documents.documents.filter((item) => {
            if (selectorTags) {
              if (item.tags) {
                let matches = item.tags.filter((i) => i.name === selectorTags);
                return matches.length > 0;
              }
              return false;
            }
            return true; // accept since no selectorKey is defined
          });
        } else {
          docs = this.$store.state.documents.documents;
        }
        docs.sort((a, b) => dateUtils.compareISOStringDates(a.dateupdated, b.dateupdated)).reverse();
        console.debug('selectorTags', selectorTags, 'latestItems', latestItems, 'DocumentsSelection docs=', docs.length);
        if (latestItems) {
          return docs.splice(0, latestItems);
        }
        return docs;
      }
      return this.$store.state.documents.documents;
    },
  },

  methods: {
    parse(dateString) {
      return dateUtils.parse(dateString);
    },
    localeDateFromString(dateString) {
      let date = dateUtils.parseISOString(dateString);
      if (date && typeof date.getMonth === 'function') {
        return dateUtils.formatAsLocaleLongDate(date);
      }
    },
  },
};
</script>
